import { createContext } from '@chakra-ui/react-utils';

const [TitleBlockProvider, useTitleBlockContext] = createContext({
  name: 'TitleBlockContext',
  errorMessage:
    'useTitleBlockContext: `context` is undefined. Seems you used a TitleBlock sub-component outside of a TitleBlock wrapping box.',
});

export { TitleBlockProvider, useTitleBlockContext };
